<template>
  <div>
    <vue-apex-charts :height="height || 400" type="area" :options="options" :series="series"/>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: { VueApexCharts },
  props: ["x", "y", "height", "format", "tooltip"],
  data() {
      return {
        options: {
          xaxis: {
            categories: this.x,
          },
          dataLabels: {
            enabled: false
          },
          fill: {
            type: "gradient",
            gradient: {
              opacityFrom: 0.5,
              opacityTo: 0.0,
              stops: [0, 90, 100]
            }
          },
          tooltip: {
            y: {
              formatter: (value, { seriesIndex, dataPointIndex }) => {
                const data = this.y[seriesIndex].tooltip;

                if (!this.tooltip)
                    return value;

                return this.tooltip(value, data ? data[dataPointIndex] : null);
              }
            }
          },
          markers: {
            size: 5,
            strokeColor: "#FFF",
            strokeWidth: 2,
            hover: {
              size: undefined,
              sizeOffset: 2
            },
          },
          yaxis: {
            labels: {
              formatter: this.format || (v => v),
            }
          }
        },
        series: this.y
      }
  }
}
</script>